<template>
  <b-card
    class="mb-2"
  >
    <div class="d-flex align-items-center mb-2">
      <div class="stat-header-icon bg-light-primary">
        <feather-icon
          icon="UsersIcon"
          size="20"
        />
      </div>

      <div class="ml-1">
        <h4 class="mb-25">
          Resumen académico
        </h4>

        <small class="text-muted">
          Aspirantes y registros
        </small>
      </div>
    </div>

    <b-row>

      <!-- Total aspirantes -->
      <b-col
        cols="12"
        sm="6"
        md="3"
      >
        <div class="stat-item">
          <div class="stat-icon bg-light-primary">
            <feather-icon
              icon="UsersIcon"
              size="18"
            />
          </div>

          <div>
            <small>Total aspirantes</small>
            <h3 class="mb-0">
              {{ formatNumber(stats.total_aspirantes) }}
            </h3>
          </div>
        </div>
      </b-col>

      <!-- ACT -->
      <b-col
        cols="12"
        sm="6"
        md="3"
      >
        <div class="stat-item">
          <div class="stat-icon bg-light-success">
            <feather-icon
              icon="UserCheckIcon"
              size="18"
            />
          </div>

          <div>
            <small>Activos</small>
            <h3 class="text-success mb-0">
              {{ formatNumber(stats.ACT) }}
            </h3>
          </div>
        </div>
      </b-col>

      <!-- CAN -->
      <b-col
        cols="12"
        sm="6"
        md="3"
      >
        <div class="stat-item">
          <div class="stat-icon bg-light-danger">
            <feather-icon
              icon="UserXIcon"
              size="18"
            />
          </div>

          <div>
            <small>Cancelados</small>
            <h3 class="text-danger mb-0">
              {{ formatNumber(stats.CAN) }}
            </h3>
          </div>
        </div>
      </b-col>

      <!-- ST2 -->
      <b-col
        cols="12"
        sm="6"
        md="3"
      >
        <div class="stat-item">
          <div class="stat-icon bg-light-warning">
            <feather-icon
              icon="UserIcon"
              size="18"
            />
          </div>

          <div>
            <small>ST2</small>
            <h3 class="text-warning mb-0">
              {{ formatNumber(stats.ST2) }}
            </h3>
          </div>
        </div>
      </b-col>

      <!-- ST3 -->
      <b-col
        cols="12"
        sm="6"
        md="3"
      >
        <div class="stat-item">
          <div class="stat-icon bg-light-info">
            <feather-icon
              icon="UserIcon"
              size="18"
            />
          </div>

          <div>
            <small>ST3</small>
            <h3 class="text-info mb-0">
              {{ formatNumber(stats.ST3) }}
            </h3>
          </div>
        </div>
      </b-col>

      <!-- ST4 -->
      <b-col
        cols="12"
        sm="6"
        md="3"
      >
        <div class="stat-item">
          <div class="stat-icon bg-light-secondary">
            <feather-icon
              icon="UserIcon"
              size="18"
            />
          </div>

          <div>
            <small>ST4</small>
            <h3 class="mb-0">
              {{ formatNumber(stats.ST4) }}
            </h3>
          </div>
        </div>
      </b-col>

      <!-- ST5 -->
      <b-col
        cols="12"
        sm="6"
        md="3"
      >
        <div class="stat-item">
          <div class="stat-icon bg-light-dark">
            <feather-icon
              icon="UserIcon"
              size="18"
            />
          </div>

          <div>
            <small>ST5</small>
            <h3 class="mb-0">
              {{ formatNumber(stats.ST5) }}
            </h3>
          </div>
        </div>
      </b-col>

      <!-- Completos -->
      <b-col
        cols="12"
        sm="6"
        md="3"
      >
        <div class="stat-item">
          <div class="stat-icon bg-light-success">
            <feather-icon
              icon="FileCheckIcon"
              size="18"
            />
          </div>

          <div>
            <small>Registros completos</small>
            <h3 class="text-success mb-0">
              {{ formatNumber(stats.registros_completos) }}
            </h3>
          </div>
        </div>
      </b-col>

      <!-- Básicos -->
      <b-col
        cols="12"
        sm="6"
        md="3"
      >
        <div class="stat-item">
          <div class="stat-icon bg-light-warning">
            <feather-icon
              icon="FileTextIcon"
              size="18"
            />
          </div>

          <div>
            <small>Registros básicos</small>
            <h3 class="text-warning mb-0">
              {{ formatNumber(stats.registros_basicos) }}
            </h3>
          </div>
        </div>
      </b-col>

    </b-row>
  </b-card>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
} from 'bootstrap-vue'
import { ref, watch } from '@vue/composition-api'
import { formatNumber } from '@core/utils/utils'

export default {
  components: {
    BCard,
    BRow,
    BCol,
  },
  props: {
    datos: {
      type: Object,
      required: true,
    },
    loader: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const stats = ref({
      total_aspirantes: 0,
      ACT: 0,
      CAN: 0,
      ST2: 0,
      ST3: 0,
      ST4: 0,
      ST5: 0,
      registros_completos: 0,
      registros_basicos: 0,
    })

    watch(
      () => props.datos,
      () => {
        if (props.datos) {
          stats.value = props.datos
        }
      },
      { immediate: true },
    )
    return {
      stats,
      formatNumber,
    }
  },
}
</script>
